export default __webpack_public_path__ + "f364376b68b8cd2582238597e965f420.png";